<template>
  <section class="empty-event-operations">
    <p
      v-if="!isSearchActive"
      class="empty-event-operations__title"
    >
      {{ $t('emptyEventOperations.youDontHaveEvents') }}
      {{ $t('emptyEventOperations.createNewEvent') }}
      <br>
      {{ $t('emptyEventOperations.toStartRepay') }}
    </p>
    <p
      v-else-if="isSearchActive"
      class="empty-event-operations__title"
    >
      {{ $t('emptyEventOperations.noEventsFound') }}
    </p>
    <button-app
      class="empty-event-operations__button"
      color-scheme="blue"
      @clicked="openAddNewEvent"
    >
      {{ $t('emptyEventOperations.newEvent') }}
    </button-app>
  </section>
</template>

<script>
import {
  SET_FINAL_USER_SELECTED_CONTACTS,
  SET_USER_SELECTED_CONTACTS,
} from '@/store/user/types';
import ButtonApp from '../Button/ButtonApp';

export default {
  name: 'EmptyEventOperations',
  components: {
    ButtonApp,
  },
  props: {
    isSearchActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openAddNewEvent() {
      const user = { ...this.$store.state.user.user };
      user.full_name = this.$t('CP.me');
      user.uid = user.user;
      this.$store.commit(SET_USER_SELECTED_CONTACTS, [user]);
      this.$store.commit(SET_FINAL_USER_SELECTED_CONTACTS, [user]);
      this.$bvModal.show('add-event');
    },
  },
};
</script>

<style scoped>
  .empty-event-operations {
    background-color: #FFFFFF;
    color: var(--text-main-color);
  }
  .empty-event-operations__button {
    width: 228px;
    height: 38px;
    font-size: 13px;
    line-height: 22px;
  }
</style>
